var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Video call")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v(" Connect video calling with client")])])]), _c('br'), _c('div', {
    staticClass: "video-window",
    class: {
      fullscreen: _vm.screenFull
    }
  }, [_c('video', {
    staticClass: "friendVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "friendsVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('video', {
    staticClass: "yourVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "yourVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('br'), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "alertClient",
      "type": "button"
    },
    on: {
      "click": _vm.showFriendsFace
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 348.077 348.077"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 348.077 348.077",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M340.273,275.083l-53.755-53.761c-10.707-10.664-28.438-10.34-39.518,0.744l-27.082,27.076     c-1.711-0.943-3.482-1.928-5.344-2.973c-17.102-9.476-40.509-22.464-65.14-47.113c-24.704-24.701-37.704-48.144-47.209-65.257     c-1.003-1.813-1.964-3.561-2.913-5.221l18.176-18.149l8.936-8.947c11.097-11.1,11.403-28.826,0.721-39.521L73.39,8.194     C62.708-2.486,44.969-2.162,33.872,8.938l-15.15,15.237l0.414,0.411c-5.08,6.482-9.325,13.958-12.484,22.02     C3.74,54.28,1.927,61.603,1.098,68.941C-6,127.785,20.89,181.564,93.866,254.541c100.875,100.868,182.167,93.248,185.674,92.876     c7.638-0.913,14.958-2.738,22.397-5.627c7.992-3.122,15.463-7.361,21.941-12.43l0.331,0.294l15.348-15.029     C350.631,303.527,350.95,285.795,340.273,275.083z",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v("Call client")])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "alertStart",
      "type": "button"
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Allow Camera")])]), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "closeVideoButton",
      "type": "button"
    },
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 32.192 32.192"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32.192 32.192",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0,17.783l0.02,2.637l0.003,0.004c0.006,0.603,0.498,1.033,1.047,1.027l0.007,0.004l7.489-0.06   c0.578-0.005,1.028-0.476,1.022-1.043l-0.021-2.64l-0.366,0.005c0.114-1.096,1.444-1.354,4.096-1.647l6.383-0.055   c1.534,0.149,3.022,0.425,3.129,1.617l-0.205,0.001l0.021,2.637l0.001,0.004c0.005,0.605,0.499,1.033,1.049,1.028l0.006,0.005   l7.488-0.062c0.579-0.002,1.027-0.474,1.023-1.041l-0.022-2.64l-0.271,0.002c-0.264-1.604-2.91-6.78-15.413-6.828   c-12.975-0.047-16.012,5.323-16.17,7.043L0,17.783z",
      "fill": "#FFFFFF"
    }
  })])]), _vm._v("Hang Up")])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "muteMicButton",
      "type": "button"
    },
    on: {
      "click": _vm.muteMic
    }
  }, [(!_vm.micIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 461.55 461.55"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 461.55 461.55",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "volume-off"
    }
  }, [_c('path', {
    attrs: {
      "d": "M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("Mute Mic")]) : _vm._e(), (_vm.micIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 461.55 461.55"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 461.55 461.55",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "volume-off"
    }
  }, [_c('path', {
    attrs: {
      "d": "M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("Unmute Mic")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "muteVideoButton",
      "type": "button"
    },
    on: {
      "click": _vm.muteVideo
    }
  }, [(!_vm.videoIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "rgb(255, 255, 255)",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "x1": "32",
      "y1": "35",
      "x2": "1",
      "y2": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Mute Video ")]) : _vm._e(), (_vm.videoIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "rgb(255, 255, 255)",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "x1": "32",
      "y1": "35",
      "x2": "1",
      "y2": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Unmute Video")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "rejectCallButton",
      "type": "button"
    },
    on: {
      "click": _vm.rejectCall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "viewBox": "0 0 21.9 21.9",
      "enable-background": "new 0 0 21.9 21.9",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z",
      "fill": "#FFFFFF"
    }
  })]), _vm._v("Reject Call")])]), _c('button', {
    staticClass: "btn btn-success btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "acceptCallButton",
      "type": "button"
    },
    on: {
      "click": _vm.acceptCall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "viewBox": "0 0 26 26",
      "enable-background": "new 0 0 26 26",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('path', {
    attrs: {
      "d": "m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z",
      "fill": "#FFFFFF"
    }
  })]), _vm._v("Accept Call")])])]), _c('form', [_c('b-form-textarea', {
    attrs: {
      "id": "textarea",
      "placeholder": "Take note..",
      "no-resize": true,
      "rows": 4,
      "max-rows": 16
    },
    model: {
      value: (_vm.noteText),
      callback: function($$v) {
        _vm.noteText = $$v
      },
      expression: "noteText"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9225f744","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VideoCall.vue
// module id = 910
// module chunks = 1